import React from "react";
import styled from "styled-components";
import { colors } from "utils";
import { BORDER, WHITE } from "./styles";

const Segmented = styled.div`
  background: ${WHITE};
  border: 1px solid ${BORDER};
  border-radius: 8px;
  display: inline-flex;
  overflow: hidden;
`;

const SegmentButton = styled.button`
  background: ${(p) => (p.$selected ? colors.blue500 : "transparent")};
  border: 0;
  border-right: 1px solid ${BORDER};
  color: ${(p) => (p.$selected ? WHITE : colors.milkGlass950)};
  font-size: 13px;
  font-weight: 500;
  padding: 7px 14px;

  &:last-child {
    border-right: 0;
  }
`;

export const SegmentedControl = ({ label, options, isSelected, onChoose }) => (
  <Segmented role="group" aria-label={label}>
    {options.map((option) => (
      <SegmentButton
        key={option.label}
        type="button"
        aria-pressed={isSelected(option)}
        $selected={isSelected(option)}
        onClick={() => onChoose(option)}>
        {option.label}
      </SegmentButton>
    ))}
  </Segmented>
);
